import React from 'react';

// Original monoline FG lettering, inspired by relaxed retro neon script.
// These are hand-shaped tube centerlines, not glyphs from a downloaded font.
const letters = [
  {
    letter: 'F',
    path:
      'M12 31 C18 21 36 17 55 18 C63 18 67 15 64 12 ' +
      'M41 20 C34 33 28 50 22 64 C19 71 14 73 12 69 C10 65 15 60 23 58 ' +
      'M17 45 C28 41 41 39 50 40',
  },
  {
    letter: 'G',
    path:
      'M109 27 C119 12 108 9 97 16 C80 26 64 47 67 59 ' +
      'C70 72 89 62 102 47 C106 42 109 36 109 36 ' +
      'C104 56 98 77 88 80 C78 83 76 75 87 66 C97 58 110 54 123 51',
  },
];

// Layered inner light / bloom reference: https://codepen.io/devindavid/pen/oZOoLq
const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="-2 0 138 94" role="img">
    <title>FG</title>
    <defs>
      <linearGradient id="neon-glass" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="var(--neon-glass-1)" />
        <stop offset="0.28" stopColor="var(--neon-glass-2)" />
        <stop offset="0.4" stopColor="var(--neon-glass-3)" />
        <stop offset="0.65" stopColor="var(--neon-glass-4)" />
        <stop offset="1" stopColor="var(--neon-glass-5)" />
      </linearGradient>
      <linearGradient id="neon-gas" x1="0" y1="0" x2="0.7" y2="1">
        <stop offset="0" stopColor="var(--green)" />
        <stop offset="0.32" stopColor="var(--neon-gas-light)" />
        <stop offset="0.52" stopColor="var(--green)" />
        <stop offset="0.78" stopColor="var(--neon-gas-mid)" />
        <stop offset="1" stopColor="var(--green)" />
      </linearGradient>
      <filter id="neon-grain" x="-10%" y="-10%" width="120%" height="120%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="1.7"
          numOctaves="3"
          seed="8"
          result="grain"
        />
        <feColorMatrix in="grain" type="saturate" values="0" />
        <feComponentTransfer>
          <feFuncR type="linear" slope="0.18" intercept="0.82" />
          <feFuncG type="linear" slope="0.18" intercept="0.82" />
          <feFuncB type="linear" slope="0.18" intercept="0.82" />
        </feComponentTransfer>
        <feComposite in2="SourceGraphic" operator="in" result="texture" />
        <feBlend in="SourceGraphic" in2="texture" mode="multiply" />
      </filter>
      <filter
        id="neon-filament"
        filterUnits="userSpaceOnUse"
        x="-8"
        y="-8"
        width="260"
        height="110">
        <feGaussianBlur stdDeviation="0.15" />
      </filter>
      <filter
        id="neon-bloom"
        x="-100%"
        y="-100%"
        width="300%"
        height="300%"
        colorInterpolationFilters="sRGB">
        <feGaussianBlur stdDeviation="1.5" result="near" />
        <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="mid" />
        <feGaussianBlur in="SourceGraphic" stdDeviation="12" result="far" />
        <feMerge>
          <feMergeNode in="far" />
          <feMergeNode in="mid" />
          <feMergeNode in="near" />
        </feMerge>
      </filter>
    </defs>
    <g className="neon-clips" fill="none">
      <path d="M25 46 L29 48 M49 16 L49 20 M72 38 L76 40 M99 59 L103 61" />
    </g>
    {letters.map(({ letter, path }) => (
      <g key={letter} className="neon-letter">
        <path className="neon-tube" d={path} />
        <path className="neon-glass-edge" d={path} />
        <g className="neon-light" data-letter={letter}>
          <path className="neon-halo" d={path} />
          <path className="neon-gas" d={path} />
          <path className="neon-core" d={path} />
        </g>
      </g>
    ))}
    <g aria-hidden="true">
      {Array.from({ length: 10 }, (_, i) => (
        <path
          key={i}
          className="neon-spark"
          data-burst={i < 5 ? '0' : '1'}
          d={i < 5 ? 'M64 12 l0.65 -1.2' : 'M123 51 l0.6 1.3'}
        />
      ))}
    </g>
  </svg>
);

export default IconLoader;
